module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114137_90_157.035d53e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114137_90_157.jpg
// module id = w1Dh
// module chunks = 0